import React, { Component } from 'react';

class ComingSoon extends Component {
  render() {
    return (
      <div className="content-wrap">
        <span>COMING SOON</span>
      </div>
    );
  }
}

export default ComingSoon;



// WEBPACK FOOTER //
// ./src/components/ComingSoon.js